import { ChangeDetectionStrategy, Component, EventEmitter, inject, input, OnInit, Output } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

import { combineLatest, map, Observable } from 'rxjs';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { ElementTypes } from '@fcom/common/interfaces/gtm.interface';
import { Step } from '@fcom/common/interfaces/step.interface';
import { MediaQueryService } from '@fcom/common/services/media-query/media-query.service';
import { BookingSteps } from '@fcom/common/interfaces/booking/booking-step.interface';
import { BookingService } from '@fcom/booking/services/booking.service';
import { BOOKING_STEPS } from '@fcom/common/config/booking-config';
import { ButtonTheme } from '@fcom/ui-components/components/buttons/button/enums';
import { IconButtonSize, IconButtonTheme } from '@fcom/ui-components/components/buttons/icon-button/enums';
import { IconPosition } from '@fcom/ui-components/components/icons/enums';

import { ShoppingCartService } from '../../services/shopping-cart.service';

export interface SubHeaderActionButton {
  label: string;
  ariaLabel?: string;
  icon: SvgLibraryIcon;
}

@Component({
  selector: 'fin-sub-header',
  styleUrls: ['sub-header.component.scss'],
  templateUrl: 'sub-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SubHeaderComponent implements OnInit {
  private mediaQueryService = inject(MediaQueryService);
  readonly isMobile = this.mediaQueryService.isBreakpoint('mobile');
  private readonly isMobile$ = toObservable(this.isMobile);
  private bookingService = inject(BookingService);
  private shoppingCartService = inject(ShoppingCartService);

  readonly ElementTypes = ElementTypes;
  readonly SvgLibraryIcon = SvgLibraryIcon;
  readonly IconButtonTheme = IconButtonTheme;
  readonly IconButtonSize = IconButtonSize;
  readonly ButtonTheme = ButtonTheme;
  readonly IconPosition = IconPosition;

  STEPS: BookingSteps = BOOKING_STEPS;

  hasBasket = input<boolean>();
  isBasketDisabled = input<boolean>();
  hasActiveBasketState = input<boolean>();
  hideDesktopBasket = input<boolean>();
  backgroundColorClass = input<string>('nordic-blue-900-bg surface-contrast');
  showInfoIcon = input<boolean>();
  staticHeight = input<boolean>(true);
  noHeader = input<boolean>(false);
  actionButton = input<SubHeaderActionButton>();
  cartButtonPositionLeft = input<boolean>(false);
  showMobileBasket = input<boolean>(false);

  @Output()
  openBasket: EventEmitter<Event> = new EventEmitter<Event>();
  @Output()
  changeStep: EventEmitter<Step> = new EventEmitter<Step>();
  @Output()
  actionButtonClick: EventEmitter<Event> = new EventEmitter<Event>();

  step$: Observable<Step>;
  showModifyButton$: Observable<boolean>;
  shoppingCartEnabled: boolean;

  constructor() {
    this.step$ = this.bookingService.step;
  }

  ngOnInit(): void {
    this.showModifyButton$ = combineLatest([this.isMobile$, this.step$]).pipe(
      map(([isMobile, step]) => !isMobile && step.phase === BOOKING_STEPS.FLIGHT_SELECTION.phase)
    );
    this.shoppingCartEnabled = this.shoppingCartService.isEnabled();
  }
}
